import * as React from 'react';
import { ReactChild } from 'react';

type TopLevelOverlayProps = {
    children: ReactChild,
    className?: string
}

function TopLevelOverlay({ children, className }: TopLevelOverlayProps) {
    return <div className={`top-level-overlay ${className}`}>
        {children}
    </div>;
}

export default TopLevelOverlay;